<template>
  <v-menu>
    <template v-slot:activator="{ props }">
      <v-btn
        icon
        v-bind="props"
        :title="$t('common.changeLanguage')"
      >
        <v-icon>mdi-translate</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="lang in languages"
        :key="lang.code"
        @click="changeLanguage(lang.code)"
        :active="currentLocale === lang.code"
      >
        <template v-slot:prepend>
          <v-icon v-if="currentLocale === lang.code">mdi-check</v-icon>
        </template>
        <v-list-item-title>{{ lang.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale } = useI18n();
    return { locale };
  },
  data() {
    return {
      languages: [
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'Français' },
      ],
    };
  },
  computed: {
    ...mapState(['locale']),
    currentLocale() {
      return this.locale;
    },
  },
  methods: {
    ...mapActions(['updateLocale']),
    changeLanguage(languageCode) {
      this.locale = languageCode;
      this.updateLocale(languageCode);
    },
  },
};
</script>

<style scoped>
</style>
